import type { AriaToastRegionProps } from '@react-aria/toast';
import { useToastRegion } from '@react-aria/toast';
import { ToastState } from '@react-stately/toast';
import { useRef } from 'react';
import { Toast } from '~/components/data-display/Toast/Toast';
import { ToastInfo } from '~/types/toast';
import styles from './ToastRegion.module.scss';

interface ToastRegionProps extends AriaToastRegionProps {
  state: ToastState<ToastInfo>;
}

export default function ToastRegion({ state, ...props }: ToastRegionProps) {
  const ref = useRef(null);
  const { regionProps } = useToastRegion(props, state, ref);

  return (
    <div {...regionProps} ref={ref} className={styles.toastRegion}>
      {state.visibleToasts.map((toast) => (
        <Toast key={toast.key} toast={toast} state={state} viewTransitionName={toast.key} />
      ))}
    </div>
  );
}
